export default __webpack_public_path__ + "static/media/ConfigureWebhookInNeto(2).13c070d7.png";